import { createListenerMiddleware } from '@reduxjs/toolkit';
import {
    getUserInfo,
    getUserProtected,
    updateUserLastLoginPortal,
} from 'lib/firebase';
import {
    retrievedUserProtectedData,
    loginSuccessful,
} from 'store/features/authentication';

export const loginMiddleware = createListenerMiddleware();
loginMiddleware.startListening({
    actionCreator: loginSuccessful,
    effect: async (action, listenerApi) => {
        const uid = action.payload.uid;
        if (!uid) return;
        getUserProtected(uid).then((userProtected) => {
            if (userProtected) {
                getUserInfo(uid).then((u) => {
                    if (u.tos) {
                        updateUserLastLoginPortal(
                            uid,
                            userProtected.supplierId
                        );
                    }
                });
                listenerApi.dispatch(retrievedUserProtectedData(userProtected));
            }
        });
    },
});
